import { render, staticRenderFns } from "./TopUpFailure.vue?vue&type=template&id=7f244d19&scoped=true&"
import script from "./TopUpFailure.vue?vue&type=script&lang=js&"
export * from "./TopUpFailure.vue?vue&type=script&lang=js&"
import style0 from "./TopUpFailure.vue?vue&type=style&index=0&id=7f244d19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f244d19",
  null
  
)

export default component.exports